import { TeamAccessDTO } from '../team/team-access.dto';

export class CannedResponseDTO extends TeamAccessDTO {

    name: string;

    content: string;

}
